module.exports = __webpack_public_path__ + "95b4c9f85c66f7d39b8932a9708872df.mp3";